import { ChangeDetectionStrategy, Component, computed, inject, Injector, signal } from '@angular/core';
import { CommonModule, NgComponentOutlet } from '@angular/common';
import { environment } from 'src/environment';
import { AdLoginComponent } from "../ad-login/ad-login.component";
import { APP_AUTH_CONFIG, AUTH_WIDGET_CONTEXT, AUTH_WIDGETS, AuthWidgetContext } from '../auth.tokens';
import { AppAuthConfig, LoginMethod } from '../auth.types';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthStore } from 'src/app/store/auth-store';
import { LoginRequest } from '../login-request.model';
import { first } from 'rxjs';
import { MatCardModule } from '@angular/material/card';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'que-login-getway',
    imports: [CommonModule, AdLoginComponent, ReactiveFormsModule, NgComponentOutlet, MatCardModule, TranslateDirective, TranslatePipe],
    templateUrl: './login-getway.component.html',
    styleUrls: ['./login-getway.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginGetwayComponent {
  private fb = inject(FormBuilder);
  private appInjector = inject(Injector);
  private cfg = inject<AppAuthConfig>(APP_AUTH_CONFIG);
  private widgets = inject(AUTH_WIDGETS);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  #authStore = inject(AuthStore);
  form = this.fb.control(null, Validators.required);

  errorKey$ = toSignal(this.#authStore.errorKey$);

  private buildPayload: () => any = () => ({});

  private readonly ctx: AuthWidgetContext = {
    form: this.form,
    registerPayloadBuilder: (builder) => { this.buildPayload = builder; }
  };

  childInjector = signal(Injector.create({
    providers: [{ provide: AUTH_WIDGET_CONTEXT, useValue: this.ctx }],
    parent: this.appInjector
  }));

  chosenMethod: LoginMethod = this.router.url.includes('/adminLogin') ?  (this.cfg.adminLoginMethod || 'ad')
    : (this.cfg.loginMethod || 'id&otp');

  selectedCmp = computed(() => this.widgets[this.chosenMethod] ?? null);

  submitting = signal(false);
  redirectTo: string = this.route.snapshot.queryParams['redirectUrl'] || '/';


  client = environment.client;
  title = environment.title;

  onSubmit() {
    this.#authStore.login({
      request: this.form.value ?? {},
      redirectTo: this.redirectTo,
      loginMethod: this.chosenMethod
    });
  }
}
